export const MOCK_PRODUCT_TYPE_1 = {
	group_id: 'checkbox_group_product_type_1',
	tabs: ['ประเภทสินค้าทั้งหมด'],
	list1: [
		{
			key: 'กล่องลังกระดาษ',
			label: 'กล่องลังกระดาษ',
		},
		{
			key: 'กล่องออฟเซ็ต',
			label: 'กล่องออฟเซ็ต',
		},
		{
			key: 'เทป',
			label: 'เทป',
		},
		{
			key: 'กล่องจั่วปัง',
			label: 'กล่องจั่วปัง',
		},
		{
			key: 'พลาสติกกันกระแทก+โฟมกันกระเเทก',
			label: 'พลาสติกกันกระแทก+โฟมกันกระเเทก',
		},
		{
			key: 'ซองพลาสติก +  ซองบับเบิ้ลกันกระแทก +ซองกระดาษ',
			label: 'ซองพลาสติก +  ซองบับเบิ้ลกันกระแทก +ซองกระดาษ',
		},
		{
			key: 'กล่องทรงกระบอก',
			label: 'กล่องทรงกระบอก',
		},
		{
			key: 'กลุ่มงานพิมพ์',
			label: 'กลุ่มงานพิมพ์',
		},
		{
			key: 'อุปกรณ์กันกระดาษภายใน',
			label: 'อุปกรณ์กันกระดาษภายใน',
		},
	],
	list2: [
		{
			key: '1',
			label: 'สินค้า 1',
		},
		{
			key: '2',
			label: 'สินค้า 2',
		},
		{
			key: '3',
			label: 'สินค้า 3',
		},
	],
}

export const MOCK_PRODUCT_TYPE_2 = {
	group_id: 'checkbox_group_product_type_2',
	tabs: ['ประเภทสินค้าทั้งหมด'],
	list1: [
		{
			key: 'กล่องลังกระดาษ',
			label: 'กล่องลังกระดาษ',
		},
		{
			key: 'กล่องออฟเซ็ต',
			label: 'กล่องออฟเซ็ต',
		},
		{
			key: 'เทป',
			label: 'เทป',
		},
		{
			key: 'กล่องจั่วปัง',
			label: 'กล่องจั่วปัง',
		},
		{
			key: 'พลาสติกกันกระแทก+โฟมกันกระเเทก',
			label: 'พลาสติกกันกระแทก+โฟมกันกระเเทก',
		},
		{
			key: 'ซองพลาสติก +  ซองบับเบิ้ลกันกระแทก +ซองกระดาษ',
			label: 'ซองพลาสติก +  ซองบับเบิ้ลกันกระแทก +ซองกระดาษ',
		},
		{
			key: 'กล่องทรงกระบอก',
			label: 'กล่องทรงกระบอก',
		},
		{
			key: 'กลุ่มงานพิมพ์',
			label: 'กลุ่มงานพิมพ์',
		},
		{
			key: 'อุปกรณ์กันกระดาษภายใน',
			label: 'อุปกรณ์กันกระดาษภายใน',
		},
	],
	list2: [
		{
			key: '1',
			label: 'สินค้า 1',
		},
		{
			key: '2',
			label: 'สินค้า 2',
		},
		{
			key: '3',
			label: 'สินค้า 3',
		},
	],
}

export const MOCK_PRODUCT_PRINTING_TYPE = {
	group_id: 'checkbox_group_printing_type',
	tabs: ['ประเภทการพิมพ์ทั้งหมด'],
	list1: [
		{
			key: 'non-print',
			label: 'Non-Print',
		},
		{
			key: 'flexo-print',
			label: 'Flexo Printing',
		},
		{
			key: 'digital-print',
			label: 'Digital Printing / Water Base',
		},
		{
			key: 'uv-inkjet',
			label: 'UV Inkjet',
		},
		{
			key: 'solvent-inkjet',
			label: 'Solvent inkjet',
		},
	],
	list2: [
		{
			key: 'non-print',
			label: 'Non-Print',
		},
		{
			key: 'flexo-print',
			label: 'Flexo Printing',
		},
		{
			key: 'digital-print',
			label: 'Digital Printing / Water Base',
		},
		{
			key: 'uv-inkjet',
			label: 'UV Inkjet',
		},
		{
			key: 'solvent-inkjet',
			label: 'Solvent inkjet',
		},
	],
}
